import React, { useMemo } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import LocaleMetadata from '../../../content/locales/descriptions.yaml'
import * as Article from 'components/ArticleComponents'

const getDescription = locale =>
	LocaleMetadata.localeDescriptions.find(localeDescription => localeDescription.locale === locale)?.description

const query = graphql`
	query AllLocalePlatformsYaml {
		allLocalePlatformsYaml {
			nodes {
				platform
				locales {
					locale
					minimumVersions
				}
			}
		}
	}
`

const LocaleTable = ({ platform, hideLocale = false }) => {
	const data = useStaticQuery(query)

	const localeEntries = useMemo(
		() =>
			data.allLocalePlatformsYaml.nodes
				.find(node => node.platform === platform)
				?.locales?.sort((a, b) => a.locale.localeCompare(b.locale))
				?.map(localeEntry => ({ ...localeEntry, description: getDescription(localeEntry.locale) })),
		[(platform, data)],
	)

	return (
		<Article.HorizontalScrollTable>
			<thead>
				<tr>
					{!hideLocale && (
						<th>
							<p>Locale</p>
						</th>
					)}
					<th>Language</th>
					<th>Minimum versions</th>
				</tr>
			</thead>

			<tbody>
				{localeEntries.map(localeEntry => (
					<tr key={localeEntry.locale}>
						{!hideLocale && (
							<td>
								<code>{localeEntry.locale}</code>
							</td>
						)}
						<td>{localeEntry.description}</td>
						<td>
							<ul>
								{localeEntry.minimumVersions.map(minimumVersion => (
									<li key={minimumVersion}>{minimumVersion}</li>
								))}
							</ul>
						</td>
					</tr>
				))}
			</tbody>
		</Article.HorizontalScrollTable>
	)
}

export default LocaleTable
